<template>
  <div class="container mb-5" id="fundo">
    <div class="col-12">
      <img src="img/parceiros.jpg" class="img img-fluid" alt="">
    </div>
    <div class="col-12 mt-5">
      <Titulo :sombra="false" titulo='Parceiros' icon="" posicao="center" style="padding-bottom: 0px !important;" class="py-0 my-0" />

      <Vue3Marquee :animate-on-overflow-only="true" :duration="(dadosParceiro.length * 3)" :pause-on-hover="true" class="justify-content-center">
        <!-- <img v-for="img in imgArray" :key="img" class="img img-fluid img-thumbnail rounded-circle mx-3 p-4" width="200" :src="img" /> -->
        <router-link v-for="parc in dadosParceiro" :key="parc.id" :to="'parceiro/'+parc.id" :title="parc.nome_empresa"
          class="img-fluid img-thumbnail rounded-circle mx-3 link_parceiro "
          :style="'background-image: url(img/parceiros/'+parc.id+'/' + parc.logo + ');'">

        </router-link>

      </Vue3Marquee>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/api';
import { Vue3Marquee } from 'vue3-marquee';
import Titulo from './Titulo.vue';

export default {
  name: 'BlocoParceiros',
  props: {
  },
  components: {
    Vue3Marquee,
    Titulo,
  },
  data() {
    return {
      dadosParceiro: [],
    }
  },
  methods: {
    async listagemTabela() {
      this.dadosParceiro = await api.post('partner/list_site')
    },
  },
  mounted() {
    this.listagemTabela()
  },
}
</script>

<style scoped>
.link_parceiro {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 80%;
  padding: 60px;
  border: 2px solid #CCC;
}
</style>